import React, { useEffect, useState } from 'react';
import { AiFillCaretLeft } from "react-icons/ai";
import { FaCaretRight } from 'react-icons/fa';
import { Form, PrimaryButton } from 'common/Forms';
import {  SelectInput } from 'common/Forms/inputs';
import { Table } from '../Table';
import { IfAtLeastMediumScreen, IfLargeScreen, IfMediumScreen, IfSmallScreen } from 'common/Grid';

const defaultPaginationSizes = [10, 20, 30, 40, 50, 60];

const paginationLabels =
{
  page: 'page',
  items: 'items',
  rows: 'rows',
  rowsPerPage: 'rows per page',
  of: 'of',
  numberFormatter: (x) => x.toLocaleString(),
};

export const Pagination = ({ id, totalItems, totalPages, pageSize, currentPage, pageSizes = defaultPaginationSizes, labels = paginationLabels, onPageChange, onPageSizeChange }) => {
  const [pageRequest, setPageRequest] = useState(currentPage + 1);
  const isMoreThanOnePage = totalPages !== undefined ? totalPages > 1 : true;
  const isFirstPage = pageRequest === 1;
  const isLastPage = totalPages !== undefined ? totalPages === pageRequest : false;
  useEffect(() => {
    setPageRequest(currentPage + 1);
  }, [currentPage])

  return (
    <Table classNames={['ui-pagination  flex items-center justify-between ']}>
      <Form classNames={['page-size-selector flex items-center gap-2']}>
        {
          <span className='rows-label capitalize whitespace-nowrap'>
            <IfMediumScreen>{labels.rows}</IfMediumScreen>
            <IfLargeScreen>{labels.rowsPerPage}</IfLargeScreen>
          </span>
        }
        <SelectInput id={`${id}-page-size-selector`}
          disabled={!pageSizes}
          selectedKey={`${pageSize}`}
          isClearable={false}
          optionProvider={() => pageSizes ?? [pageSize]}
          keySelector={x => `${x}`}
          labelSelector={x => `${x}`}
          onChange={(_, n) => n && onPageSizeChange ? onPageSizeChange(n) : null} />
        {
          <span className='items-info whitespace-nowrap'>
            {
              pageSize && isMoreThanOnePage
                ? <IfAtLeastMediumScreen>
                  {labels.numberFormatter(pageSize * currentPage + 1)}
                  {<> {'\u2014'} </>}
                  {labels.numberFormatter(totalItems ? Math.min(pageSize * (currentPage + 1), totalItems) : pageSize * (currentPage + 1))}
                  <IfLargeScreen>
                    {
                      totalItems ? <> {labels.of} {labels.numberFormatter(totalItems)}</> : <></>
                    }
                  </IfLargeScreen>
                  {<> {labels.items}</>}
                </IfAtLeastMediumScreen>
                : <></>
            }
            <IfSmallScreen> {labels.rows}</IfSmallScreen>
          </span>
        }
      </Form>
      <Form>
        <nav className='flex  items-center flex-row gap-2'>
          {
            isMoreThanOnePage
              ? <>
                {
                  isFirstPage
                    ? <></>
                    : <PrimaryButton action={() => onPageChange ? onPageChange(currentPage - 1) : null}><AiFillCaretLeft /></PrimaryButton>
                }
                <IfAtLeastMediumScreen><span className='page-label capitalize'>{labels.page} {currentPage + 1}</span></IfAtLeastMediumScreen>
                {/* <IntegerInput id={`${id}-page-input`}
                  value={pageRequest}
                  min={1}
                  max={totalPages}
                  isEmptyAllowed={false}
                  onChange={(_, n) => n ? setPageRequest(n) : setPageRequest(1)}
                  onEnter={() => pageRequest !== currentPage + 1 && onPageChange ? onPageChange(pageRequest - 1) : null} /> */}
                {
                  totalPages
                    ? <span className='pages-info whitespace-nowrap'> {labels.of} {labels.numberFormatter(totalPages)}</span>
                    : <></>
                }
                {
                  isLastPage
                    ? <></>
                    : <PrimaryButton action={() => onPageChange ? onPageChange(currentPage + 1) : null}><FaCaretRight /></PrimaryButton>
                }
              </>
              : totalItems !== undefined ? <span className='pages-info whitespace-nowrap'>{totalItems} {labels.items}</span> : <></>
          }
        </nav>
      </Form>
    </Table>
  );
};
